export const TOKENID_FETCHING = 'TOKENID_FETCHING';
export const TOKENID_FETCHED = 'TOKENID_FETCHED';
export const TOKEN_SENT = 'TOKEN_SENT';
export const TOKEN_MULTIPLE_CANCEL = 'TOKEN_MULTIPLE_CANCEL';
export const RESERVE_CONFIRMED_AT_SEARCHPAGE = 'RESERVE_CONFIRMED_AT_SEARCHPAGE';
